import React from "react";

type IconProps = {
  size?: number;
  className?: string;
};

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

export const FolderIcon = ({ size = 18, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <path {...stroke} d="M3.5 7.5A2 2 0 0 1 5.5 5.5h4.2l1.6 2H18.5a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" />
  </svg>
);

export const ChevronIcon = ({ size = 14, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <path {...stroke} d="M9 6l6 6-6 6" />
  </svg>
);

export const PlusIcon = ({ size = 16, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <path {...stroke} d="M12 5v14M5 12h14" />
  </svg>
);

export const SearchIcon = ({ size = 16, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <circle {...stroke} cx="11" cy="11" r="6.5" />
    <path {...stroke} d="M16.2 16.2L21 21" />
  </svg>
);

export const GridIcon = ({ size = 16, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <rect {...stroke} x="4" y="4" width="6.5" height="6.5" rx="1.5" />
    <rect {...stroke} x="13.5" y="4" width="6.5" height="6.5" rx="1.5" />
    <rect {...stroke} x="4" y="13.5" width="6.5" height="6.5" rx="1.5" />
    <rect {...stroke} x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5" />
  </svg>
);

export const ListIcon = ({ size = 16, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <path {...stroke} d="M9 6.5h11M9 12h11M9 17.5h11" />
    <path {...stroke} d="M4.5 6.5h.01M4.5 12h.01M4.5 17.5h.01" strokeWidth={2.4} />
  </svg>
);

export const CheckIcon = ({ size = 14, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <path {...stroke} strokeWidth={2} d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
);

export const LinkIcon = ({ size = 16, className }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden>
    <path {...stroke} d="M9.5 14.5l5-5" />
    <path {...stroke} d="M8 16.5a3.5 3.5 0 0 1 0-5l2.2-2.2a3.5 3.5 0 0 1 5 5L13.8 15.7" />
    <path {...stroke} d="M16 7.5a3.5 3.5 0 0 1 0 5l-2.2 2.2a3.5 3.5 0 1 1-5-5L10.2 8.3" />
  </svg>
);
